<template>
    <div :class="[tabsMainClass, { 'userpage': userPage }]">
        <div :class="[`${tabsMainClass}__titles-container`]">
            <div :class="[tabsMainClass, { '-wrap': wrap }] ">
                <div :class="[`${tabsMainClass}__titles-container-wrapper`]">
                    <div :class="getTabClass(tab)" @click="onTabClick(tab)" :key='tab.id' v-for="tab in tabs" :data-text="tab.title">
                        <span v-if="tab.icon" :class="[`${tabsMainClass}__icon`, tab.icon]"></span>
                        <span :class="[`${tabsMainClass}__title`]" v-html="tab.title"></span>
                    </div>
                </div>
            </div>
        </div>
        <slot name="custom-content"></slot>
        <div :class="tabsMainClass">
            <div class="tab-content">
                <slot :onTabMounted="onTabMounted" :activeTab="activeTab"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Tabs',
        data () {
            return {
                tabs: [],
                activeTab: null,
                activeRoute: this.$route.name
            }
        },
        props: {
            tabsMainClass: {
                type: String,
                default: ''
            },
            wrap: {
                type: Boolean,
                default: false
            },
            userPage: {
                type: Boolean,
                default: false
            }
        },
        provide: function () {
            return {
                activateTab: this.activateTab,
            }
        },
        methods: {
            onTabClick (tab) {
                if (tab.routerLink) {
                    this.$router.push({ name: tab.routerLink.name }).catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                            console.error(err)
                        }
                    })
                } else {
                    this.activeTab = tab
                }
            },
            activateTab (tabId) {
                this.activeTab = this.tabs.find(tab => tab.id === tabId)
            },
            onTabMounted (tab) {
                if (tab.routerLink && tab.routerLink.name === this.activeRoute) {
                    this.activeTab = tab
                    this.tabs.push(tab)
                    return
                }
                if (!this.activeTab) {
                    this.activeTab = tab
                }
                this.tabs.push(tab)
            },
            getTabClass (tab) {
                const tabClass = [`${this.tabsMainClass}__tab-title`]
                if (tab.id === this.activeTab.id) {
                    tabClass.push(`${this.tabsMainClass}__tab-title--active`)
                }
                return tabClass
            }
        }
    }
</script>
